import { render, staticRenderFns } from "./IrrigationUpkeepTable.vue?vue&type=template&id=28f05893&scoped=true&lang=html&"
import script from "./IrrigationUpkeepTable.vue?vue&type=script&lang=js&"
export * from "./IrrigationUpkeepTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f05893",
  null
  
)

export default component.exports